import React, { useEffect } from 'react';
import { Button, Empty, Spin } from 'antd';
import { observer } from 'mobx-react';
import { useDoc31Store } from '../../../contexts/mobx';
import { DOC31_DEFAULT_TIMEZONE } from '../../../utils/doc31';
import { groupDoc31HistoryByDay } from './format';
import { Doc31HistoryEntry } from './history-entry';
import style from './style.module.scss';

export const Doc31HistoryTab: React.FC = observer(() => {
    const store = useDoc31Store();
    const {
        editionKey,
        changeCount,
        history,
        hasMoreHistory,
        isLoadingHistory,
        historyLoadFailed,
    } = store;
    const timezone = store.view?.timezone ?? DOC31_DEFAULT_TIMEZONE;

    // The tab stays mounted: refetch the first page after every write.
    useEffect(() => {
        store.fetchHistory();
    }, [store, editionKey, changeCount]);

    if (historyLoadFailed && !isLoadingHistory) {
        return (
            <div className={style.loading}>
                <Empty description="Couldn't load history.">
                    <Button onClick={() => store.fetchHistory()}>
                        Try again
                    </Button>
                </Empty>
            </div>
        );
    }

    if (history.length === 0) {
        return isLoadingHistory ? (
            <div className={style.loading}>
                <Spin />
            </div>
        ) : (
            <p className={style.empty}>
                No changes yet. Saves, state changes and coupon edits show up
                here.
            </p>
        );
    }

    return (
        <div className={style.history}>
            {groupDoc31HistoryByDay(history, timezone).map((day) => (
                <section key={day.key}>
                    <h3 className={style.day_heading}>{day.heading}</h3>
                    <ol className={style.timeline}>
                        {day.events.map((event) => (
                            <Doc31HistoryEntry
                                key={event.id}
                                event={event}
                                timezone={timezone}
                            />
                        ))}
                    </ol>
                </section>
            ))}
            {hasMoreHistory && (
                <Button
                    className={style.more}
                    loading={isLoadingHistory}
                    onClick={() => store.fetchHistory({ more: true })}
                >
                    Show older
                </Button>
            )}
        </div>
    );
});
